<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ type }} {{ $t('Banners') }}</h2>
			<div class="mb-4">
				<label class="block mb-2" for="banner_name">{{ $t('Nombre') }}</label>
				<input
					type="text"
					v-model="banner.name"
					id="title"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.banner.name.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.banner.name.required"
					>
						{{ $t('name_required') }}
					</div>
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.banner.name.maxLength"
					>
						{{ $t('name_validation') }}
					</div>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="currentcountry">País</label>
				<select
					ref="currentcountry"
					id="currentcountry"
					v-model="banner.country_id"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option
						v-for="(country, index) in countries"
						:value="country.id"
						:key="index"
						:selected="country.id == banner.country_id"
					>
						{{ country.name }}
					</option>
				</select>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="order">{{ $t('Orden') }}</label>
				<input
					type="number"
					v-model="banner.order"
					id="title"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.banner.order.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.banner.order.required"
					>
						{{ $t('orden_required') }}
					</div>
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.banner.order.numeric"
					>
						{{ $t('orden_validation') }}
					</div>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2">{{ $t('publication_date') }}</label>
				<datepicker
					v-model="banner.publishing_date"
					:full-month-name="true"
					:language="es"
					:inline="true"
					:monday-first="true"
					:disabled-dates="disabledDates"
				>
				</datepicker>
				<div v-if="$v.banner.publishing_date.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.banner.publishing_date.required"
					>
						{{ $t('publication_date_required') }}
					</div>
				</div>
			</div>
			<h3 class="max-w-md" v-if="image || banner.image">
				{{ (image && image.name) || (banner.image && banner.image.file_name) }}
			</h3>
			<img-upload
				:image="image"
				@upload-image="img_upload"
				@reset-image="img_reset"
			/>
			<div v-if="$v.image.$dirty">
				<div class="text-sm text-red-500 mt-2" v-if="!$v.image">
					{{ $t('image_validation') }}
				</div>
			</div>
			<!-- <div class="mb-4">
        <div v-if="!this.id">
          <img-upload :image="image" />
          <p class="text-sm mb-4">* {{ $t('image_text') }}</p>
        </div>
        <div v-else>
          <span class="block mb-2">{{ $t('image') }}</span>
          <img class="max-w-md" :src="image.temp + '?getImage=1'">
        </div>
        <div v-if="$v.image.temp.$dirty">
          <div class="text-sm text-red-500 mt-2" v-if="!$v.image.temp.required">{{ $t('image_required') }}</div>
        </div>
      </div> -->
			<!-- <div class="mb-4">
        <label class="block mb-2" for="roles_group">{{$t("roles_template")}}</label>
        <select id="roles_group" v-model="rol_group_selected" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" @change="onChangeGroup()">
          <option v-for="(group, index) in roles_group" :value="group.id" :key="index">
            {{ group.group }}
          </option>
        </select>
      </div> -->
			<label>{{ $t('Roles') }}</label>
			<dual-list
				v-if="DualListOptions"
				id="vueduallist"
				:options="DualListOptions"
			/>
			<div v-if="$v.DualListOptions.selectedItems.$dirty">
				<div
					class="text-sm text-red-500 mt-2"
					v-if="!$v.DualListOptions.selectedItems.required"
				>
					{{ $t('roles_required') }}
				</div>
			</div>

			<div class="mt-4 flex justify-end">
				<ButtonBlack @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import DualList from '@/components/DualList.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ImgUpload from '@/components/ImgUpload.vue'
import { single, uploadImage } from '@/mixins'
import { required, maxLength, url, numeric } from 'vuelidate/lib/validators'
import { fetchCountriesSelect } from '@/apollo/countries'
import { fetchRolesSelect } from '@/apollo/roles'
import { fetchBanner, updateBanner, insertBanner } from '@/apollo/banners'

export default {
	apollo: {
		roles: fetchRolesSelect(),
		countries: fetchCountriesSelect(),
		banner() {
			const query = fetchBanner(this.id)
			query.skip = this.id == null
			return query
		}
	},
	data() {
		return {
			section: 'banners',
			disabledDates: {
				to: this.id ? null : this.$moment().subtract(1, 'days').toDate()
			},
			banner: {
				name: '',
				country_id: '',
				roles: this.id ? null : [],
				image: null,
				publishing_date: new Date(),
				order: ''
			},
			roles: null,
			countries: [],
			es: es,
			image: null
		}
	},
	validations() {
		return {
			banner: {
				name: {
					required,
					maxLength: maxLength(100)
				},
				order: {
					required,
					numeric
				},
				publishing_date: {
					required
				}
			},
			image: function (img) {
				return img || this.banner.image
			},
			DualListOptions: {
				selectedItems: {
					required
				}
			}
		}
	},
	watch: {
		roles: function (data) {
			if (this.banner.roles !== null && this.DualListOptions === null) {
				this.loadRolesList(data, this.banner.roles)
			}
		},
		banner: function (data) {
			if (
				this.id != null &&
				this.roles !== null &&
				this.DualListOptions === null
			) {
				this.loadRolesList(this.roles, data.roles)
			}
		}
	},
	components: {
		datepicker,
		DualList,
		ImgUpload,
		PulseLoader
	},
	props: {
		id: String
	},
	mixins: [single, uploadImage],
	methods: {
		img_reset() {
			this.image ? (this.image = null) : (this.banner.image = null)
		},
		img_upload(img) {
			this.image = img
		},
		loadRolesList(roles, selected) {
			this.loadDualList(
				roles,
				selected
					? selected
							.map(org => roles.find(elem => elem.id == org.id))
							.filter(elem => elem != null)
					: selected
			)
		},

		async updateSingleBanner() {
			if (this.image)
				this.banner.image = await this.uploadImage(
					this.banner,
					'banners',
					this.image
				)
			const mutationData = {
				bannerId: this.id,
				bannerData: this.getBannerUpdateData(),
				bannerRoles: this.DualListOptions.selectedItems
			}
			await this.$apollo.mutate(updateBanner(mutationData))
		},

		async insertSingleBanner() {
			if (this.image)
				this.banner.image = await this.uploadImage(
					this.banner,
					'banners',
					this.image
				)
			const mutationData = {
				bannerData: this.getBannerInsertData(),
				bannerRoles: this.DualListOptions.selectedItems
			}
			await this.$apollo.mutate(insertBanner(mutationData))
		},

		getBannerUpdateData() {
			return {
				country_id: this.banner.country_id,
				banner_name: this.banner.name,
				publishing_date: this.banner.publishing_date,
				order: this.banner.order,
				image_id: this.banner.image ? this.banner.image.id : null
			}
		},

		getBannerInsertData() {
			return {
				country_id: this.banner.country_id,
				banner_name: this.banner.name,
				publishing_date: this.banner.publishing_date,
				order: this.banner.order,
				image: this.banner.image ? { data: this.banner.image } : undefined
			}
		},

		async submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				;(this.id ? this.updateSingleBanner() : this.insertSingleBanner())
					.then(() => this.stopLoadingState())
					.catch(error => this.setError(error))
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	}
}
</script>
